import { oc } from '@orpc/contract';
import { listVehiclesInputSchema, listVehiclesOutputSchema } from '../schemas/vehicles.schemas.js';
export const listVehiclesContract = oc
    .route({
    method: 'GET',
    path: '/vehicles',
    tags: ['Vehicles'],
    summary: 'List vehicles with search, filters, sorting and pagination',
})
    .input(listVehiclesInputSchema)
    .output(listVehiclesOutputSchema);
//# sourceMappingURL=list-vehicles.contract.js.map